import { useState } from 'react';

import { PERM } from '#/config/permissions';
import {
  Tabs,
  TabsContent,
  TabsList,
  TabsTrigger,
} from '#/modules/commonComponents/tabs';
import SnDirectSaleSection from '#/modules/crmMgmt/salesOrder/components/SnDirectSaleSection';
import SnWarrantyLookupSection from '#/modules/crmMgmt/salesOrder/components/SnWarrantyLookupSection';
import { useCan } from '#/modules/infra/auth/useCan';
import PageShell from '#/modules/infra/layout/PageShell';

const TAB_LOOKUP = 'lookup';
const TAB_DIRECT_SALE = 'direct-sale';

/**
 * 序號直接銷售與保固（內部）：
 * - Tab「保固查詢」GET …/{mtrSnId}（read）；更正 PATCH（review）
 * - Tab「直接售出」POST …/sn-sales-warranties/direct-sale（create）
 * 客戶自行查詢走客戶站 `/customer/api/v1`，不在此頁。
 */
const SnSalesWarrantyPage = () => {
  const canCreate = useCan(PERM.SALES_ORDER_CREATE);
  const canReview = useCan(PERM.SALES_ORDER_REVIEW);
  const [tab, setTab] = useState(TAB_LOOKUP);
  const [lookupSerial, setLookupSerial] = useState('');

  function handleSold(serialNumber) {
    setLookupSerial(serialNumber);
    setTab(TAB_LOOKUP);
  }

  return (
    <PageShell variant="detail">
      <div className="flex h-full flex-col overflow-auto p-1">
        <div className="mx-auto flex w-full max-w-3xl flex-col gap-4">
          <h1 className="page_title mb-0!">
            <span className="border-l-5 border-primary-400 pl-2.5">序號直接銷售</span>
          </h1>

          <Tabs value={tab} onValueChange={setTab}>
            <TabsList className="shrink-0 flex-wrap justify-start bg-slate-200 p-1">
              <TabsTrigger value={TAB_LOOKUP}>保固查詢</TabsTrigger>
              {canCreate ? (
                <TabsTrigger value={TAB_DIRECT_SALE}>直接售出</TabsTrigger>
              ) : null}
            </TabsList>

            <TabsContent value={TAB_LOOKUP} className="mt-4 outline-none">
              <SnWarrantyLookupSection
                key={lookupSerial}
                serialNumber={lookupSerial}
                onSearch={setLookupSerial}
                canCorrect={canReview}
              />
            </TabsContent>

            {canCreate ? (
              <TabsContent value={TAB_DIRECT_SALE} className="mt-4 outline-none">
                <SnDirectSaleSection onSold={handleSold} />
              </TabsContent>
            ) : null}
          </Tabs>
        </div>
      </div>
    </PageShell>
  );
};

export default SnSalesWarrantyPage;
